
import React from 'react';
import { Chip, Tooltip } from '@mui/material';

const ChipComponent = ({ value, row, handleOpenCostStatusViewer }) => {
    switch (value) {
        case 'Not Required':
            return (
                <Chip
                    label={value}
                    size="small"
                    sx={{ backgroundColor: '#bdbdbd', color: 'white' }}
                />
            );
        case 'Not Started':
            return (
                <Chip
                    label={value}
                    size="small"
                    sx={{ backgroundColor: '#FFA500', color: 'black' }}
                />
            );
        case 'Draft':
            return (
                <Tooltip title={`Last updated at ${row.last_updated_at} by ${row.last_updated_by}`} placement="top">
                    <Chip
                        label={value}
                        size="small"
                        color="primary"
                        onClick={() => handleOpenCostStatusViewer(row.id, row.month)}
                        sx={{ cursor: 'pointer' }}
                    />
                </Tooltip>
            );
        case 'Submitted':
            return (
                <Tooltip title={`Submitted at ${row.last_updated_at} by ${row.last_updated_by}`} placement="top">
                    <Chip
                        label={value}
                        size="small"
                        color="primary"
                        onClick={() => handleOpenCostStatusViewer(row.id, row.month)}
                        sx={{ 
                            cursor: 'pointer', 
                            backgroundColor: '#007500', 
                            color: 'white' 
                        }}
                    />
                </Tooltip>
            );
        case 'Submitted Late':
            return (
                <Tooltip title={`Submitted at ${row.last_updated_at} by ${row.last_updated_by}`} placement="top">
                    <Chip
                        label={value}
                        size="small"
                        color="primary"
                        onClick={() => handleOpenCostStatusViewer(row.id, row.month)}
                        sx={{ 
                            cursor: 'pointer', 
                            backgroundColor: '#ff5b5b', 
                            color: 'black',
                        }}
                    />
                </Tooltip>
            );
            default:
            return null;
    }
};

export default ChipComponent;
